<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Wykluczenia opcji</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li class="active">
          <strong>Wykluczenia opcji</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Wykluczenia opcji</h5>
          </div>
          <div class="ibox-content">
            <router-link
              v-if="canAddExclusion"
              to="/product-option-exclusion/create"
            >
              <button class="btn btn-sm btn-primary">Dodaj</button>
            </router-link>
            <div class="row">
              <div class="col-sm-12 m-b-xs">
                <div class="form-group">
                  <label class="control-label col-sm-2">
                    Wpisz liczbę wierszy:
                  </label>
                  <div class="col-sm-2">
                    <input
                      class="form-control inputClass"
                      type="text"
                      v-model="rowsPerPage"
                      @change="setRowsPerPage"
                      @click="isSearch = false"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 m-b-xs" v-if="items">
                <button @click="resetFilters" class="btn btn-primary btn-xs">
                  <i class="fa fa-refresh"></i>
                </button>
                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select v-model="serverOptions.rowsPerPage">
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input type="number" v-model="serverOptions.page" /> -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="serverOptions.page = serverOptions.page - 1"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="serverOptions.page = serverOptions.page + 1"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
                <EasyDataTable
                  v-model:server-options="serverOptions"
                  :server-items-length="itemsAll"
                  :headers="headers"
                  :items="items"
                  :clickRowToExpand="true"
                  :loading="loading"
                  @expand-row="editPOEX"
                  alternating
                  multi-sort
                  border-cell
                  @update-sort="updateSort"
                  class="table-search"
                >
                  <template #header="header">
                    <span v-if="header.text">{{ header.text }}</span>
                    <input
                      class="table-search"
                      type="text"
                      v-if="header.search"
                      v-model="searchValue[header.value]"
                      @keyup="search"
                      @click="isSearch = true"
                    />
                  </template>
                  <template #expand>
                    <div class="row">
                      <div class="col-lg-12">
                        <div class="ibox float-e-margins">
                          <div class="ibox-title">
                            <h5>Dane wykluczenia opcji</h5>
                          </div>

                          <div class="form-horizontal">
                            <div class="ibox-content">
                              <div class="form-group">
                                <label class="control-label col-sm-2">
                                  Opcja 1
                                </label>
                                <div class="col-sm-10">
                                  <Multiselect
                                    v-model="pOptionsExObj.option_1"
                                    mode="single"
                                    placeholder="Opcja 1"
                                    track-by="name"
                                    label="name"
                                    :close-on-select="true"
                                    :searchable="true"
                                    :options="options"
                                  >
                                  </Multiselect>
                                  <div
                                    v-if="errorsAdminData?.data?.option_1"
                                    class="has-error"
                                  >
                                    <span class="help-block">
                                      {{ errorsAdminData.data.option_1[0] }}
                                    </span>
                                  </div>
                                </div>
                              </div>

                              <div class="form-group">
                                <label class="control-label col-sm-2">
                                  Opcja 2
                                </label>
                                <div class="col-sm-10">
                                  <Multiselect
                                    v-model="pOptionsExObj.option_2"
                                    mode="single"
                                    placeholder="Opcja 2"
                                    track-by="name"
                                    label="name"
                                    :close-on-select="true"
                                    :searchable="true"
                                    :options="options"
                                  >
                                  </Multiselect>
                                  <div
                                    v-if="errorsAdminData?.data?.option_2"
                                    class="has-error"
                                  >
                                    <span class="help-block">
                                      {{ errorsAdminData.data.option_2[0] }}
                                    </span>
                                  </div>
                                </div>
                              </div>

                              <div class="hr-line-dashed"></div>

                              <div class="form-group">
                                <div class="col-sm-4 col-sm-offset-2">
                                  <button class="btn btn-white" @click="cancel">
                                    Anuluj
                                  </button>
                                  <button
                                    v-if="canChangeExclusion"
                                    @click="saveEdit"
                                    class="btn btn-primary"
                                  >
                                    Zapisz
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template #item-actions="item">
                    <button
                      v-if="canDeleteExclusion"
                      @click.stop="
                        showModal = item.pk;
                        deleteName =
                          item.option_1.label_pl + ' ' + item.option_2.label_pl;
                      "
                      class="btn btn-danger btn-xs"
                    >
                      <i class="fa fa-trash"></i>
                    </button>
                  </template>
                </EasyDataTable>
                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select v-model="serverOptions.rowsPerPage">
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input type="number" v-model="serverOptions.page" /> -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="serverOptions.page = serverOptions.page - 1"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="serverOptions.page = serverOptions.page + 1"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Modal
    v-if="showModal"
    :title="'Potwierdzenie usunięcia'"
    :content="'Czy na pewno chcesz usunąć <b>' + deleteName + '</b> ?'"
    @callbackOk="deletePOEX(showModal)"
    @callbackClose="showModal = false"
  />
</template>

<script>
import { computed, watch, ref, onMounted } from "vue";
import { useStore } from "vuex";
import { hasPermission } from "../../permissions";
import { exclusionPermissionsConst } from "../../constants/productConstants";
import Modal from "../caffeprint/Modal.vue";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";

export default {
  name: "ProductOptionExList",
  mixins: [],
  components: {
    Modal,
    Multiselect,
  },
  props: {},

  setup() {
    const store = useStore();
    const canAddExclusion = computed(() =>
      hasPermission(exclusionPermissionsConst.add)
    );
    const canChangeExclusion = computed(() =>
      hasPermission(exclusionPermissionsConst.update)
    );
    const canDeleteExclusion = computed(() =>
      hasPermission(exclusionPermissionsConst.delete)
    );
    const deletepOptionsExData = computed(
      () => store.getters.getDeletepOptionsExData
    );
    const poexData = computed(() => store.getters.getPOEXData);
    const updatepOptionsExData = computed(
      () => store.getters.getUpdatepOptionsExData
    );
    const pOptionsExData = computed(() => store.getters.getpOptionsExData);
    const adminProductOptionsData = computed(
      () => store.getters.getAdminProductOptionsData
    );
    const pOptionsExObj = ref({});
    const options = ref([]);
    let headers = [
      {
        text: "ID #1",
        value: "option_1.pk",
        sortable: true,
        search: true,
      },
      {
        text: "Nazwa #1",
        value: "option_1.label_pl",
        sortable: true,
        search: true,
      },
      {
        text: "Opis #1",
        value: "option_1.description_pl",
        sortable: true,
        search: true,
      },
      {
        text: "ID #2",
        value: "option_2.pk",
        sortable: true,
        search: true,
      },
      {
        text: "Nazwa #2",
        value: "option_2.label_pl",
        sortable: true,
        search: true,
      },
      {
        text: "Opis #2",
        value: "option_2.description_pl",
        sortable: true,
        search: true,
      },
      { text: "Data dodania", value: "date_added", sortable: true },
      { text: "Data modyfikacji", value: "date_modified", sortable: true },
      {
        text: "Zmodyfikowano przez",
        value: "last_modified_by",
        sortable: true,
      },
      {
        text: "Utworzono przez",
        value: "created_by",
        sortable: true,
      },
      { text: "Akcje", value: "actions" },
    ];

    let items = ref([]);
    let itemsAll = ref(0);
    const showModal = ref(false);
    const deleteName = ref("");
    const loading = ref(true);
    const searchValue = ref({});
    const isSearch = ref(false);
    const rowsPerPage = ref();
    const defRowsPerPage = ref(25);
    const serverOptions = ref({
      page: 1,
      rowsPerPage: defRowsPerPage.value,
    });

    const getpOptionsEx = async () => {
      loading.value = true;
      let sort;
      if (serverOptions.value.sortType === "desc") {
        sort = "-" + serverOptions.value.sortBy;
      } else {
        sort = serverOptions.value.sortBy;
      }
      await store.dispatch("getpOptionsEx", {
        page: serverOptions.value.page,
        itemsPerPage: serverOptions.value.rowsPerPage,
        ordering: sort,
        search: searchValue.value,
      });
    };

    const deletePOEX = (pk) => {
      showModal.value = false;
      if (!canDeleteExclusion.value) {
        return;
      }
      store.dispatch("deletepOptionsEx", {
        pk: pk,
      });
    };
    const saveEdit = () => {
      if (!canChangeExclusion.value) {
        return;
      }
      store.dispatch("updatepOptionsEx", pOptionsExObj.value);
    };

    const cancel = () => {
      document.querySelector(".expanding")?.click();
    };

    const editPOEX = (globalIndex) => {
      cancel();
      const localIndex =
        globalIndex - (serverOptions.value.page - 1) * defRowsPerPage.value;
      store.dispatch("getPOEX", { pk: items.value[localIndex].pk });
    };

    const search = () => {
      isSearch.value = true;
      if (searchValue.value) {
        setTimeout(() => {
          selectPage(1);
          getpOptionsEx();
          isSearch.value = false;
        }, 1000);
      }
    };

    const selectPage = (page) => {
      serverOptions.value.page = page;
    };

    const resetFilters = () => {
      selectPage(1);
      searchValue.value = {};
      serverOptions.value.sortBy = "";
      getpOptionsEx();
    };

    const updateSort = () => {
      search.value = true;
    };
    store.dispatch("getAdminProductOptions");

    const setRowsPerPage = () => {
      serverOptions.value.rowsPerPage = rowsPerPage.value;
    };

    onMounted(() => {
      if (localStorage.getItem("productEXSearchValue") !== null) {
        searchValue.value = localStorage.getItem("productEXSearchValue");
        searchValue.value = JSON.parse(searchValue.value);
      }

      getpOptionsEx();
    });

    watch(
      () => searchValue.value,
      function () {
        localStorage.setItem(
          "productEXSearchValue",
          JSON.stringify(searchValue.value)
        );
        getpOptionsEx();
      },
      { deep: true }
    );

    watch(
      () => pOptionsExData.value,
      function (newValue) {
        itemsAll.value = newValue.data.count;
        items.value = [];
        newValue.data.results?.forEach((element) => {
          items.value.push(element);
        });
        loading.value = false;
      }
    );

    watch(
      () => poexData.value,
      function (newValue) {
        pOptionsExObj.value = newValue.data;
      }
    );

    watch(
      () => deletepOptionsExData.value,
      function (newValue) {
        if (newValue.status === 204) {
          store.dispatch("showToaster", {
            type: "success",
            content: "Wykluczenie opcji zostało usunięte",
          });
        }
        getpOptionsEx();
      }
    );

    watch(
      () => updatepOptionsExData.value,
      function (newValue) {
        if (newValue.status === 200) {
          getpOptionsEx();
          store.dispatch("showToaster", {
            type: "success",
            content: "Dane zostały zaktualizowane",
          });
        }

        cancel();
      }
    );

    watch(
      () => adminProductOptionsData.value,
      function (newValue) {
        newValue.data?.forEach((element) => {
          options.value.push({
            name: "[" + element.pk + "] " + element.label,
            value: element.pk,
          });
        });
      }
    );

    watch(
      () => serverOptions.value,
      function () {
        if (!isSearch.value) {
          getpOptionsEx();
          isSearch.value = false;
        }
      },
      { deep: true }
    );

    return {
      canAddExclusion,
      canChangeExclusion,
      canDeleteExclusion,
      headers,
      items,
      itemsAll,
      loading,
      serverOptions,
      showModal,
      deletePOEX,
      deleteName,
      pOptionsExObj,
      cancel,
      editPOEX,
      saveEdit,
      searchValue,
      search,
      resetFilters,
      updateSort,
      isSearch,
      rowsPerPage,
      options,
      setRowsPerPage,
      selectPage,
    };
  },
  computed: {},
};
</script>
